<template>
  <div class="group relative">
    <VTooltip
      class="h-[inherit]"
      :placement="placement"
      :disabled="disabled || (!text && !slots.body && !slots.header)"
    >
      <div class="peer h-[inherit]">
        <slot>
          <icon class="cursor-pointer" src="bold/info" />
        </slot>
      </div>

      <template #popper>
        <div
          :class="{
            'bg-bgr-inverse rounded-[4px]': props.type === 'default',
            'bg-bgr-primary shadow-on-top rounded-xl': props.type === 'secondary',
          }"
        >
          <p
            class="text-body-small tracking-[0.26px]"
            :class="{
              'text-fgr-white': props.type === 'default',
              'max-w-[300px]': !props.fullWidth,
            }"
          >
            <slot name="header">
              {{ text }}
            </slot>
          </p>
          <slot name="body" />
        </div>
      </template>
    </VTooltip>
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      disabled?: boolean;
      placement?:
        | "auto"
        | "auto-start"
        | "auto-end"
        | "top"
        | "top-start"
        | "top-end"
        | "right"
        | "right-start"
        | "right-end"
        | "bottom"
        | "bottom-start"
        | "bottom-end"
        | "left"
        | "left-start"
        | "left-end";
      text?: string;
      type?: "default" | "secondary";
      fullWidth?: boolean;
    }>(),
    {
      disabled: false,
      placement: "bottom",
      text: "",
      type: "default",
      fullWidth: false,
    }
  );

  const slots = useSlots();
</script>

